import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const PasswordSent = () => {
  const navigate = useNavigate();
  const handleMove = () => navigate('/reset-password');
  const { t } = useTranslation();

  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="bg-white flex flex-col w-full h-full p-7 items-center py-6 justify-center sm:h-auto sm:w-96 sm:rounded-xl">
        <span className="text-lg font-medium mb-2">
          {t('auth.check_email_text')}
        </span>
        <p className="text-base text-center" onClick={handleMove}>
          {t('auth.check_email_desc')}
        </p>
      </div>
    </div>
  );
};
